import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

interface SpinnerProps {
  label?: string;
  className?: string;
}

/** 로딩 인디케이터 — lucide Loader2 회전(Admin Kit·shadcn spinner 관례). 크기는 className(`size-*`)으로. */
export function Spinner({ label = '처리 중', className }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      className={cn('size-6 animate-spin text-primary', className)}
    />
  );
}
